import {Component, Input} from '@angular/core';
import {RowStateTracker} from '../../../utils/RowStateTracker';

// Header/tab/group-row indicator for a table with at least one row "in modifica"/"modificata"/
// "nuova"/"eliminata": a single yellow dot, gone once the tracker is back to normal.
@Component({
  selector: 'app-row-state-badge',
  templateUrl: './row-state-badge.component.html',
  styleUrls: ['./row-state-badge.component.css']
})
export class RowStateBadgeComponent {

  // Array so a tab header can aggregate every grid it contains (e.g. group table + metric
  // table); a standalone table header just passes a single-element array.
  @Input() trackers: (RowStateTracker | undefined)[] = [];

  // When set, only rows of that group count (see RowStateTracker scope).
  @Input() scoped = false;
  @Input() scope: any;

  get visible(): boolean {
    return this.trackers.some(t => !!t && (this.scoped ? t.hasAnyIn(this.scope) : t.hasAny()));
  }
}
